export default "__VITE_ASSET__NehqzeKb__"